import React, { useState, useEffect, useRef } from "react"
import {
  Table,
  Button,
  Tooltip,
  Result,
  ColorPicker,
  Collapse,
  Popconfirm,
} from "antd"
import * as Http from "utils/http.helper"
import UpsertModal from "./modals/upsert"
import { getColumnSearchProps } from "utils/filter"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
const { Panel } = Collapse

const PrintStyleColorManagement = () => {
  document.title = "Color Management | EASY JET CONNECT"
  const searchInput = useRef(null)
  const [loading, setLoading] = useState(true)
  const [upsertModal, setUpsertModal] = useState({
    show: false,
    data: null,
  })
  const [color, setColor] = useState([])
  const [searchText, setSearchText] = useState("")
  const [options, setOptions] = useState([])
  const getData = () => {
    setLoading(true)
    Http.get(`api/orders/GetAllPrintProperties`)
      .then(res => {
        if (res?.success) {
          const color = []
          res.data.map(item => {
            item.colors.map(x => {
              color.push({
                styleId: item.styleId,
                styleName: item.styleName,
                hexCode: x.hexCode,
                name: x.name,
                id: x.id,
              })
            })
          })
          setColor(color)
          setOptions({
            styles: res.data.map(item => {
              return {
                label: item.styleName,
                value: item.styleId,
              }
            }),
          })
          setLoading(false)
        }
      })
      .catch(function (error) {
        setLoading(false)
        toastr.error(error.response.data.Message)
      })
  }

  useEffect(() => {
    getData()
  }, [])

  const onDelete = id => {
    setLoading(true)
    Http.post(`api/PrintColors/remove`, {
      colorId: id,
    })
      .then(res => {
        if (res?.success) {
          toastr.success("Deletion completed successfully")
          getData()
          setLoading(false)
        } else {
          toastr.error(res?.Message)
          setLoading(false)
        }
      })
      .catch(function (error) {
        setLoading(false)
        toastr.error(error.response.message)
      })
  }

  const columnsColor = [
    {
      title: "Style Name",
      dataIndex: "styleName",
      key: "styleName",
      ...getColumnSearchProps(
        "styleName",
        "Filter by color style name",
        searchInput,
        searchText,
        setSearchText
      ),
      sorter: (a, b) => a.styleName.localeCompare(b.styleName),
    },
    {
      title: "Color Name",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps(
        "name",
        "Filter by color name",
        searchInput,
        searchText,
        setSearchText
      ),
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Color",
      dataIndex: "hexCode",
      key: "hexCode",
      render: (_, row) => {
        return (
          <ColorPicker
            size="small"
            value={row.hexCode}
            // defaultValue={`${row.hexCode}`}
            showText
            disabled
          />
        )
      },
    },
    {
      title: " ",
      key: "action",
      align: "center",
      width: 120,
      render: (_, record) => (
        <div
          className="d-flex align-items-center justify-content-start"
          style={{ columnGap: 10 }}
        >
          {/* <Tooltip placement="top" title="Edit Color">
            <Button
              type="button"
              className="btn btn-primary d-flex align-items-center justify-content-center m-auto"
              icon={<i className="mdi mdi-pencil" />}
              onClick={() => {
                setUpsertModal({ show: true, data: record })
              }}
            />
          </Tooltip> */}
          <Popconfirm
            title="Attention!"
            description={
              <>
                Are you sure you want to delete color{" "}
                <span style={{ fontWeight: "700" }}>{record.name}</span> ?
              </>
            }
            onConfirm={() => {
              onDelete(record.id)
            }}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip placement="top" title="Delete">
              <Button
                className="btn btn_quinary d-flex align-items-center justify-content-center m-auto"
                type="button"
                icon={<i className="mdi mdi-delete" />}
                style={{ marginRight: 5 }}
              />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
  ]

  let localeColor = {
    emptyText: (
      <Result
        title="No data"
        subTitle="If you haven't selected any company or added financial data yet, you can select and list a company or create a new financial value."
      />
    ),
  }

  return (
    <React.Fragment>
      {upsertModal.show && (
        <UpsertModal
          upsertModal={upsertModal}
          setUpsertModal={setUpsertModal}
          loading={loading}
          setLoading={setLoading}
          getData={getData}
          options={options}
        />
      )}
      <div className="page-content mb-3">
        <Collapse activeKey={["1"]} expandIcon={() => false}>
          <Panel
            key="1"
            header={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                Color Managemenet
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    columnGap: "15px",
                  }}
                >
                  <div>
                    <Button
                      className="btn btn-primary d-flex align-items-center justify-content-end"
                      onClick={() => setUpsertModal({ show: true, data: null })}
                      icon={
                        <i className="bx bx-plus font-size-16 align-middle"></i>
                      }
                    >
                      Add Color
                    </Button>
                  </div>
                </div>
              </div>
            }
          >
            <Table
              size="small"
              bordered
              columns={columnsColor}
              dataSource={color}
              className="table table-centered"
              loading={loading}
              locale={localeColor}
              pagination={{
                position: ["bottomCenter"],
              }}
            />
          </Panel>
        </Collapse>
      </div>
    </React.Fragment>
  )
}

export default PrintStyleColorManagement
